import { Component, OnInit } from '@angular/core';
import { environment } from './../../../../environments/environment';

@Component({
  	selector: 'app-toolcards-overview',
  	templateUrl: './toolcards-overview.component.html',
  	styleUrls: ['./toolcards-overview.component.scss']
})
export class ToolcardsOverviewComponent implements OnInit {
	public env;

  	constructor() { }

  	ngOnInit() {
  		this.env=environment;
  	}

}
